import { render, staticRenderFns } from "./aShopSms.vue?vue&type=template&id=61342ea4&scoped=true"
import script from "./aShopSms.vue?vue&type=script&lang=js"
export * from "./aShopSms.vue?vue&type=script&lang=js"
import style0 from "./aShopSms.vue?vue&type=style&index=0&id=61342ea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61342ea4",
  null
  
)

export default component.exports